export const eventBio = {
  venue:
    "Hairat Ade Balogun Auditorium, Body of Benchers Headquarters, Plot 688, Institute and Research District FCC, Phase III, Abuja - FCT",
  date: "18th July 2024",
};
